import React from 'react';
import { SizeProps } from '@src/v3/interfaces/assets/svg';

const Size = ({
  width = '25',
  height = '24',
  viewBox = '0 0 25 24',
  stroke = 'currentColor',
  strokeWidth,
  strokeLinecap,
  strokeLinejoin,
  useNewPaths = false,
  ...props
}: SizeProps) => {
  // Old path data (default)
  const oldPaths = [
    { d: 'M9.5 5.25L12.5 2.25L15.5 5.25' },
    { d: 'M12.5 21.75V2.25' },
    { d: 'M15.5 18.75L12.5 21.75L9.5 18.75' },
  ];

  // New path data
  const newPaths = [
    { d: 'M6 3.5L8 1.5L10 3.5' },
    { d: 'M8 14.5V1.5' },
    { d: 'M10 12.5L8 14.5L6 12.5' },
  ];

  const paths = useNewPaths ? newPaths : oldPaths;
  const defaultStrokeWidth = useNewPaths ? '1.5' : '2';
  const defaultStrokeLinecap = useNewPaths ? 'round' : undefined;
  const defaultStrokeLinejoin = useNewPaths ? 'round' : undefined;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      {...props}
    >
      {paths.map((path, index) => (
        <path
          key={index}
          d={path.d}
          stroke={stroke}
          strokeWidth={strokeWidth ?? defaultStrokeWidth}
          strokeLinecap={strokeLinecap ?? defaultStrokeLinecap}
          strokeLinejoin={strokeLinejoin ?? defaultStrokeLinejoin}
        />
      ))}
    </svg>
  );
};

export default Size;
